import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { FiMail } from "react-icons/fi";
import { AiFillCaretRight } from "react-icons/ai";
import FeedbackContext from "../../context/cmscontext";
import { useContext } from "react";
import Labels from "../../services/apiLabels";
import { POST } from "../../constant/apiMethods";
import { FORGET_PASSWORD } from "../../constant";
import { scrollTop } from "../../utils/window";
import AuthShell from "../../components/AuthShell/AuthShell";
import "../Login Page/dealers-login.css";

const FORGET_VISUAL = "/images/dealers-benefits-ops.jpg?v=1";

export const Forget = ({ passworedReset }) => {
  const { feedback } = useContext(FeedbackContext);
  const forget_password_page = feedback.forget_password_page || {};
  const [email, setemail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    scrollTop();
    return () => {
      document.body.style.background = "";
    };
  }, []);

  const reSetPassword = (event) => {
    if (event) event.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    passworedReset({ email }, () => setSubmitting(false));
  };

  return (
    <AuthShell
      visualImage={FORGET_VISUAL}
      visualTitle="Reset access to"
      visualTitleAccent=" the floor."
      visualPoints={[
        "Secure email reset link",
        "Back to bidding fast",
        "Dealer desk support",
      ]}
      activeCta="login"
    >
      <div className="dl-panel__inner">
        <p className="dl-eyebrow">Account recovery</p>
        <h1 className="dl-title">
          {forget_password_page.forget_pass_text || "Forgot password"}
        </h1>
        <p className="dl-lede">
          Enter your dealer email and we’ll send reset instructions so you can
          get back to the trade floor.
        </p>

        <form className="dl-form" onSubmit={reSetPassword} autoComplete="on">
          <div className="dl-field">
            <label htmlFor="forget-email">Email address</label>
            <input
              id="forget-email"
              type="email"
              value={email}
              onChange={(e) => setemail(e.target.value)}
              className="dl-input"
              placeholder={
                forget_password_page.email_placeholder || "Email address"
              }
              autoComplete="email"
              required
            />
          </div>

          <button
            type="submit"
            className="dl-submit"
            name="CTAButton"
            disabled={submitting}
          >
            <FiMail size={16} aria-hidden />
            {submitting
              ? "Sending…"
              : forget_password_page.btn_forget_pass || "Send reset link"}
          </button>
        </form>

        <p className="dl-footer-note">
          Remembered your password?{" "}
          <Link to="/login">
            Back to login
            <AiFillCaretRight size={14} aria-hidden />
          </Link>
        </p>
      </div>
    </AuthShell>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  passworedReset: (data, callBack) =>
    dispatch({
      type: FORGET_PASSWORD,
      payload: {
        type: FORGET_PASSWORD,
        label: Labels.password_Reset,
        method: POST,
        data,
        hideOverlayLoader: true,
        callBack,
      },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Forget);
